import {Component, OnInit} from '@angular/core';
import {Md5} from 'ts-md5';
import {CustomerService} from '../../services/customer.service';
import {SharedService} from '../../services/shared.service';
import {MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-password-dialog',
  templateUrl: './password-dialog.component.html',
  styleUrls: ['./password-dialog.component.scss']
})
export class PasswordDialogComponent implements OnInit {
  enteredPassword: string;
  showLoader: boolean;
  showSentForgotRequest: boolean;

  constructor(public dialogRef: MatDialogRef<PasswordDialogComponent>,
              private customerService: CustomerService,
              private shared: SharedService) {
  }

  ngOnInit() {
  }

  checkPassword(password) {
    let md5 = Md5.hashStr(password);
    this.customerService.getCurrentCustomer(true)
      .then(customer => {
        if (customer.passwordCheck(md5)) {
          this.shared.setPasswordPass(customer.passwordCheck(md5));
        } else {
          this.shared.openErrorDialog({title: 'Error', body: 'Invalid password'});
        }
        this.dialogRef.close();
      })
      .catch(_ => {
        this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error. Please try again'});
      });
  }

  forgotPassword() {
    this.showLoader = true;
    this.customerService.getCurrentCustomer(true)
      .then(customer => {
        return this.customerService.forgotPasswordRequest(customer.uid);
      })
      .then(res => {
        this.showLoader = false;
        this.showSentForgotRequest = true;
      })
      .catch(_ => {
        this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error. Please try again'});
      });
  }

}
